import '@/styles/globals.css'
import Head from "next/head";
import Script from "next/script";
import Layout from "../comps/Layout";
import Link from 'next/link';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getCookie, setCookie } from "cookies-next";
import { i18n } from "../comps/i18n"

export default function App({ Component, pageProps }) {

  const [t, i18n] = useTranslation();
  const language = i18n.language;
 
  useEffect(() => {
    const savedLang = getCookie('language');
    if (savedLang && savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
    } else if (!savedLang) {
      i18n.changeLanguage('ar');
      setCookie('language', 'ar');
    }
  }, []);

  return (
    <>
      <Head>
        <title>Sigma Machines</title>
        <meta name="description" content="Generated by create next app" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </>
  )
}
